"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cards = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function Cards(_a) {
    var channel = _a.channel, onDelete = _a.onDelete, user = _a.user;
    var playlists = ra_fetch_1.useApi('backend').index('playlists', {
        channel_id: channel.id,
        videos_total: true,
    })[0];
    if (playlists.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (!playlists.data.length) {
        return react_1.default.createElement(storybook_1.Forms.New, { description: 'Je hebt nog geen playlists', label: 'Nieuwe playlists', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/playlists/create", icon: 'plus' });
    }
    return react_1.default.createElement(storybook_1.Grids.List, null, playlists.data.map(function (playlist) { return react_1.default.createElement(storybook_1.Cards.Card, { key: playlist.id },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement("div", { className: 'flex justify-between' },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(storybook_1.Texts.Primary, null, playlist.label),
                    react_1.default.createElement(storybook_1.Texts.Secondary, null,
                        playlist.videos_total || 0,
                        " ",
                        playlist.videos_total === 1 ? 'video' : 'video\'s')),
                react_1.default.createElement("div", { className: 'flex items-center' },
                    user.permissions.includes('api.playlists.update') &&
                        react_1.default.createElement(storybook_1.Buttons.Link, { className: 'inline-block', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/playlists/" + playlist.id + "/edit" },
                            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'pencil', className: 'storybook-icons-icon mr-2' })),
                    user.permissions.includes('api.playlists.destroy') &&
                        onDelete && react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return onDelete(playlist); } },
                        react_1.default.createElement(storybook_1.Icons.Icon, { name: 'trash', className: 'storybook-icons-icon' })))))); }));
}
exports.Cards = Cards;
Cards.propTypes = {
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * On Delete action
     */
    onDelete: prop_types_1.default.func,
};
Cards.defaultProps = {};
